<template>
  <SFButton
    variant="raw"
    fab
    size="sm"
    class="size-10 border border-gray-200 text-gray-500"
    :aria-label="$t('global.back')"
    :to="isBrandsPage ? localePath(routeList.brands.path) : link"
  >
    <template #append-icon="{ _class }">
      <IconChevronLeft :class="_class" />
    </template>
  </SFButton>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import type { Category } from '@scayle/storefront-nuxt'
import { useRouteHelpers } from '~/composables'
import { routeList } from '~/utils'
import { SFButton } from '#storefront-ui/components'
import { useRoute } from '#app/composables/router'
import { useLocalePath } from '#i18n'

const { path } = useRoute()
const localePath = useLocalePath()

const { currentCategory } = defineProps<{ currentCategory: Category | null }>()

const { buildCategoryPath, getLocalizedRoute } = useRouteHelpers()

const isBrandsPage = computed(
  () => currentCategory?.parent?.slug === 'brands' && path.includes('/b/'),
)

const link = computed(() => {
  return currentCategory?.parent
    ? buildCategoryPath(currentCategory.parent)
    : getLocalizedRoute(routeList.home.path)
})
</script>
